import * as React from 'react'
import { InjectedIntlProps } from 'react-intl'
import { Dropdown } from 'src/elements/Dropdown'

import { locale } from './locale'

const style = require('./Dropdowns.css')

interface UserDropdownProps {
  viewer: any; // TODO: generate types from GQL requests
  shown: boolean;
}

interface HostEventsDropdownProps {
  shown: boolean;
}

interface HelpDropdownProps {
  shown: boolean;
}

export const UserDropdown: React.FunctionComponent<UserDropdownProps & InjectedIntlProps> = ({
  shown,
  viewer,
  intl,
}) => (
  <Dropdown shown={shown} className={style.userDropdown}>
    {(viewer.host || viewer.memberships.nodes.length > 0) && (
      <React.Fragment>
        <Dropdown.Link to="/dashboard">
          {intl.formatMessage(locale.dashboard)}
        </Dropdown.Link>
        <Dropdown.Link to="/dashboard/my-events">
          {intl.formatMessage(locale.eventsYouAreHosting)}
        </Dropdown.Link>
        <Dropdown.Separator />
      </React.Fragment>
    )}
    <Dropdown.Link to="/dashboard/tickets">
      {intl.formatMessage(locale.myTickets)}
    </Dropdown.Link>
    <Dropdown.Separator />
    <Dropdown.Link to={`/users/${viewer.slug}`}>
      {intl.formatMessage(locale.profile)}
    </Dropdown.Link>
    <Dropdown.Link to="/dashboard/conversations">
      {intl.formatMessage(locale.messages)}
    </Dropdown.Link>
    <Dropdown.Link to="/dashboard/settings">
      {intl.formatMessage(locale.settings)}
    </Dropdown.Link>
    <Dropdown.Link to="/help">
      {intl.formatMessage(locale.help)}
    </Dropdown.Link>
    <Dropdown.Link to="/users/sign_out">
      {intl.formatMessage(locale.logOut)}
    </Dropdown.Link>
  </Dropdown>
)

export const HostEventsDropdown: React.FunctionComponent<HostEventsDropdownProps & InjectedIntlProps> = ({
  shown,
  intl,
}) => (
  <Dropdown shown={shown} className={style.hostEventsDropdown}>
    <Dropdown.Link to="/create">
      {intl.formatMessage(locale.createEvent)}
    </Dropdown.Link>
    <Dropdown.Separator />
    <Dropdown.Link to="/features">
      {intl.formatMessage(locale.features)}
    </Dropdown.Link>
    <Dropdown.Link to="/customers">
      {intl.formatMessage(locale.customers)}
    </Dropdown.Link>
    <Dropdown.Link to="/pricing">
      {intl.formatMessage(locale.pricing)}
    </Dropdown.Link>
  </Dropdown>
)

export const HelpDropdown: React.FunctionComponent<HelpDropdownProps & InjectedIntlProps> = ({
  shown,
  intl,
}) => (
  <Dropdown shown={shown} className={style.helpDropdown}>
    <Dropdown.Link to="/help">
      {intl.formatMessage(locale.helpCenter)}
    </Dropdown.Link>
    <Dropdown.Separator />
    <Dropdown.Link to="/help/find_tickets">
      {intl.formatMessage(locale.cantFindTickets)}
    </Dropdown.Link>
    <Dropdown.Link to="/help/contact_organizer">
      {intl.formatMessage(locale.contactOrganizer)}
    </Dropdown.Link>
    <Dropdown.Link to="/help/get_refund">
      {intl.formatMessage(locale.canRefund)}
    </Dropdown.Link>
  </Dropdown>
)

